<div [formGroup]="frm" class="dyreportalen-wrapper flex-wrapper project">
  <div class="flex-item">
    <label for="search-wildlife-filter-project">Valg av prosjekt:</label>
    <select
      (change)="projectSelected()"
      [formControl]="frm.controls.projects"
      id="search-wildlife-filter-project"
      multiple
      size="4">
      @for (val of dataProjects; track val) {
        <option [value]="val">{{ val }}</option>
      }
    </select>
  </div>

  <div class="flex-item individual">
    <label for="search-wildlife-filter-individual">Valg av individ:</label>
    <select
      #individualsRef
      [formControl]="frm.controls.individuals"
      id="search-wildlife-filter-individual"
      multiple
      size="4">
      @for (val of dataIndividuals; track val) {
        <option [value]="val">
          {{ val }}
        </option>
      }
    </select>
  </div>

  <div class="flex-item period" [class.inactive]="!isPeriodActive">
    <label for="search-wildlife-filter-period">Valg av periode:</label>

    @if (!isPeriodActive) {
      <div>Ikke relevant for datamengde "Siste&nbsp;registrerte"</div>
    }

    @if (isPeriodActive) {
      <div class="period-picker">
        <mat-date-range-input [max]="maxDate" [rangePicker]="picker" separator="">
          <input
            matStartDate
            (dateChange)="dateStartPicked($event.value)"
            [formControl]="frm.controls.periodStart"
            [max]="dateToday"
            id="search-wildlife-filter-period"
            placeholder="Fra dato" />
          <input
            matEndDate
            (dateChange)="dateEndPicked($event.value)"
            [formControl]="frm.controls.periodEnd"
            [max]="dateToday"
            placeholder="Til dato" />
        </mat-date-range-input>
        <mat-date-range-picker #picker></mat-date-range-picker>
        <button (click)="picker.open()" [disabled]="!isPeriodActive" class="btn--rangepicker mat-mdc-filled-button">
          <mat-icon>event</mat-icon>
          Velg periode
        </button>
      </div>
    }
  </div>

  <div class="flex-item quantity">
    <label for="search-wildlife-filter-dataset">Valg av datamengde:</label>
    <select [formControl]="frm.controls.quantity" id="search-wildlife-filter-dataset">
      @for (val of dataQuantities; track val) {
        <option [value]="val">
          {{ val }}
        </option>
      }
    </select>
    <button (click)="search()" (keyup.enter)="search()" class="search mat-mdc-filled-button">
      @if (fetchingAnimals) {
        <mat-spinner [diameter]="19" color="primary" class="loading" mode="indeterminate"></mat-spinner>
      }
      <span>Søk{{ fetchingAnimals ? 'er..' : '' }}</span>
    </button>

    @if (formFeedback?.length && !fetchingAnimals) {
      <div class="feedback">
        {{ formFeedback }}
      </div>
    }

    <div class="feedback">
      @if (frm.controls.periodStart.hasError('matDatepickerMax')) {
        <span>Startdato kan ikke være høyere enn dagens dato.</span>
      }
      @if (frm.controls.periodEnd.hasError('matDatepickerMax')) {
        <span>Sluttdato kan ikke være høyere enn dagens dato.</span>
      }
      @if (frm.hasError('date_range_invalid')) {
        <span>Sluttdato må være nyere enn startdato.</span>
      }
    </div>
  </div>
</div>
